var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MTableCell',{staticClass:"m-table-cell__checkbox"},[_c('MCheckbox',{attrs:{"value":_vm.value},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }